import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function About() {
  return (
    <>
      <Helmet>
        <title>About Us - RMQ Digital</title>
        <meta name="description" content="Learn about RMQ Digital's mission to provide professional customer communication services with A2P 10DLC compliance." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>About RMQ Digital</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>Professional Business Communication Solutions</p>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
        {/* Team Image */}
        <div style={{ marginBottom: '4rem', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.1)' }}>
          <img 
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=500&fit=crop" 
            alt="Professional team working together" 
            style={{ width: '100%', height: '500px', objectFit: 'cover' }}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem', marginBottom: '4rem' }}>
          <div>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#6d28d9', marginBottom: '1rem' }}>Our Mission</h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563' }}>
              At RMQ Digital, we empower businesses to connect with their customers through compliant, 
              secure customer communication tools. We provide appointment reminders, service notifications, 
              and account alerts while maintaining strict regulatory compliance and delivering measurable results.
            </p>
          </div>

          <div>
            <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#6d28d9', marginBottom: '1rem' }}>Our Values</h2>
            <ul style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#4b5563', listStyle: 'none', padding: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>✓ Compliance First</li>
              <li style={{ marginBottom: '0.5rem' }}>✓ Customer Privacy</li>
              <li style={{ marginBottom: '0.5rem' }}>✓ Transparent Pricing</li>
              <li style={{ marginBottom: '0.5rem' }}>✓ Quality Service</li>
              <li style={{ marginBottom: '0.5rem' }}>✓ Innovation</li>
            </ul>
          </div>
        </div>

        <div style={{ background: '#f9fafb', padding: '3rem', borderRadius: '12px', marginBottom: '4rem' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '2rem', textAlign: 'center' }}>
            Why Choose RMQ Digital?
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
            {[
              { title: 'A2P 10DLC Compliant', desc: 'Fully registered and compliant with carrier requirements' },
              { title: 'High Deliverability', desc: '99%+ message delivery rates with premium routing' },
              { title: 'Expert Support', desc: 'Dedicated team to help you succeed' },
              { title: 'Transparent Reporting', desc: 'Real-time analytics and detailed campaign reports' }
            ].map((item, idx) => (
              <div key={idx} style={{ textAlign: 'center' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#6d28d9', marginBottom: '0.5rem' }}>
                  {item.title}
                </h3>
                <p style={{ color: '#6b7280', lineHeight: '1.6' }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={{ textAlign: 'center', padding: '3rem 0' }}>
          <h2 style={{ fontSize: '2rem', fontWeight: '700', color: '#1f2937', marginBottom: '1rem' }}>
            Ready to Get Started?
          </h2>
          <p style={{ fontSize: '1.1rem', color: '#6b7280', marginBottom: '2rem' }}>
            Join hundreds of businesses using RMQ Digital for secure customer communications
          </p>
          <a href="/contact" style={{ 
            display: 'inline-block',
            background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%)',
            color: 'white',
            padding: '1rem 2.5rem',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '1.1rem',
            transition: 'all 0.3s ease'
          }}>
            Contact Us Today
          </a>
        </div>
      </div>
    </>
  );
}
